import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'stores-platforms' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
